module.exports = __webpack_public_path__ + "media/images/congélateur-d4abd5dd132c8b0483c791aef3631ae0.svg";